import { createRovoOpsSpotlightPlacement } from './create-rovo-ops-spotlight-placement';

export const ROVO_OPS_ALERT_DETAIL_SELECTOR = '#rovo-ops-cta-panel-spotlight-target';

const rovoOpsAlertDetailSpotlightPlacement: ReturnType<typeof createRovoOpsSpotlightPlacement> =
	createRovoOpsSpotlightPlacement({
		placementId: 'rovo-ops-alert-detail-spotlight',
		selector: ROVO_OPS_ALERT_DETAIL_SELECTOR,
	});

export const MessageFrontend: typeof rovoOpsAlertDetailSpotlightPlacement.MessageFrontend =
	rovoOpsAlertDetailSpotlightPlacement.MessageFrontend;

export const PlacementFrontend: typeof rovoOpsAlertDetailSpotlightPlacement.PlacementFrontend =
	rovoOpsAlertDetailSpotlightPlacement.PlacementFrontend;
